import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./OrderDetail.css";
import { useDispatch, useSelector } from "react-redux";
import {  Table } from "react-bootstrap";
import ProductDetaile from "./ProductDetaile";
import { fetchUIDGallery } from "../Redux/GalleryUIDRedux";

function OrderDetail(props) {
 const dispatch = useDispatch();
  const posts = useSelector((state) => state.RequestOrder);

  const [viewBox, setViewBox] = useState({ Hide: false });
  const openDetailedDilogBox = async (UID) => {
    await dispatch(fetchUIDGallery(UID));

    setViewBox({ Hide: true });
  };
  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        size="md"
      >
        <Modal.Header closeButton className="Titel02">
          <Modal.Title id="contained-modal-title-vcenter">
            Detail View
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="ArtBox02">
          <div className={posts.isFilled + " Div01"}>
            <Table hover>
              <thead>
                <tr className="Header">
                  <td>Product</td>
                  <td>Price per Pice</td>
                  <td>Purchase Qty/Price</td>
                </tr>
              </thead>

              <tbody>
                {posts.data?.map((post) => (
                  <tr key={"a" + post.UID}>
                    <td>
                      <div className="PhotosFrame03">
                        <img
                          className="Photos03"
                          src={
                            // process.env.REACT_APP_BackEndIP +"/Static/Art/" +post.UID +"/1.png"
                            
                    `${process.env.REACT_APP_BackEndIP}/Static/Art/${post.UID}/1.png?${new Date().getTime()}`
                          }
                          onClick={() => openDetailedDilogBox(post.UID)}
                          alt="Not Available"
                        />
                      </div>
                      <div className="FilterBar06">
                        <strong>{post.Name}</strong>
                      </div>
                    </td>
                    <td className="TextFrame02">
                      <div>{"Rs:" + post.Price}</div>
                    </td>

                    <td className="FilterBar06">
                      <div className="FilterBar05">
                        <input
                          className="PageIP02"
                          value={post.CQty}
                          disabled
                        />
                      </div>

                      <div>
                        {"Total Rs:" +
                          parseInt(post.Price) * parseInt(post.CQty)}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>

      <ProductDetaile
        show={viewBox.Hide}
        onHide={() => setViewBox({ Hide: false })}
      />
    </>
  );
}

export default OrderDetail;
